import { CButton, CButtonGroup, CCol, CContainer, CDropdown, CDropdownItem, CDropdownMenu, CDropdownToggle, CForm, CFormGroup, CInput, CInputGroup, CInputGroupAppend, CLabel, CRow } from '@coreui/react';
import { resolve } from 'path';
import * as React from 'react';
import { Redirect } from 'react-router';
import { Table } from 'reactstrap';
import { IPoolInfo, IRunX3WSResult } from '../abstraction';
import { KStressLine } from '../components';
import { AppLabels } from '../core/AppLabels';
import { dispatcher, securitySvc } from '../Karma';

interface InfoLine {
	id: number;
	startTime: Date;
	endTime: Date;
	status: number;
	statusSrv: number;
	message: string;
	duration: number;
	durationSrv: number;
}

interface IProps {
}

interface IState {
	wsDropDown: boolean;
	wsName: string;
	wsPool: string;
	wsParams: string;
	nbCalls: number;
	interval: number;
	intervalUnit: string;
	intervalMax: number;
	rows: InfoLine[];
	isRunning: boolean;
	poolList: IPoolInfo[];
}

export enum rStat {
	Error = -1,
	Wait,
	Pending,
	Cancelled,
	Ended
}

export class Stress extends React.Component<IProps, IState> {
	static URL: string = "/Stress/";

	public constructor(props: any) {
		super(props);

		this.state = {
			wsDropDown: false,
			wsPool: "",
			wsName: "X1KMAPAGE",
			wsParams: "<PARAM></PARAM>",
			nbCalls: 10,
			interval: 1,
			intervalUnit: "s",
			intervalMax: 60,
			rows: [],
			isRunning: false,
			poolList: [],

		};

	}

	componentDidMount = () => {
		dispatcher.getPoolList().then((result) => {
			this.setState({ poolList: result })
		})
	}

	toggle = () => this.setState({ wsDropDown: !this.state.wsDropDown });

	componentWillUnmount = () => { securitySvc.inactivityOn = true }

	onNbCallChange = (event) => {
		this.setState({ nbCalls: event.target.value, });
	}

	onIntervalChange = (event) => {
		this.setState({ interval: event.target.value, });
	}

	onParamsChange = (event) => {
		this.setState({ wsParams: event.target.value, });
	}

	onWsNameChange = (event) => {
		this.setState({ wsName: event.target.value, });
	}

	onWsPoolChange = (event) => {
		this.setState({ wsPool: event.target.value, });
	}


	prepare = async () => {
		let newTab: InfoLine[] = [];

		for (let call = 0; call < this.state.nbCalls; call++) {
			var item: InfoLine = {
				duration: 0,
				durationSrv: 0,
				endTime: new Date(),
				id: call,
				message: AppLabels.wait,
				startTime: new Date(),
				status: rStat.Wait,
				statusSrv: 0
			}

			newTab.push(item);
		}

		this.setState({
			rows: newTab,
			isRunning: true
		}, () => resolve());
	}

	onClickLaunchStress = async (event) => {
		await this.prepare();
		securitySvc.inactivityOn = false;
		for (let call = 0; call < (this.state.nbCalls) && this.state.isRunning == true; call++) {
			let current = this.state.rows.filter(r => r.id == call)[0];
			current.startTime = new Date();
			current.message = AppLabels.inProgress;
			current.status = rStat.Pending
			this.forceUpdate();

			dispatcher.runX3WS(this.state.wsName, this.state.wsParams, this.state.wsPool)
				.then((result: IRunX3WSResult) => {
					current.status = rStat.Ended;
					current.message = result.message != "" ? result.message : AppLabels.ok;
					current.endTime = new Date();
					current.duration = current.endTime.getTime() - current.startTime.getTime();
					current.statusSrv = result.status;
					current.durationSrv = result.duration;
					this.makeIsRunningFalse();
					this.forceUpdate();
				})
				.catch((reason: any) => {
					current.status = rStat.Error;
					current.message = reason != "" ? reason : "KO - Exception";
					current.endTime = new Date();
					current.duration = current.endTime.getTime() - current.startTime.getTime();
					current.statusSrv = 0;
					current.durationSrv = 0;
					this.makeIsRunningFalse();
					this.forceUpdate();
				});
			await this.delay(this.state.intervalUnit == "ms" ? this.state.interval : this.state.interval * 1000);
			//condition?oui:non;
		}
	}

	makeIsRunningFalse = () => {
		if (this.state.rows.filter(r => r.status == rStat.Wait)[0] == undefined) this.setState({ isRunning: false });
	}

	onClickCancelStress = (event) => {
		this.makeIsRunningFalse();
		this.state.rows.filter(r => (r.status == rStat.Wait)).map(r => { r.message = AppLabels.canceled; r.status = rStat.Cancelled });
		securitySvc.inactivityOn = true;
	}

	onClickIntervalUnit = (event) => {
		switch (event.target.id) {
			case 'buttonUnit-s': {
				this.setState({ intervalUnit: "s", intervalMax: 60 });
				break;
			}
			case 'buttonUnit-ms': {
				this.setState({ intervalUnit: "ms", intervalMax: 1000 })
			}
		}
		this.setState({ interval: 1 })
	}

	delay(delay: number) {
		return new Promise(resolve => {
			setTimeout(() => {
				resolve(true);
			}, delay);
		});
	}

	//#region Rendus

	renderTable() {
		if (this.state.rows.length == 0) return "";

		return (<Table size="sm" >
			<thead>
				<tr>
					<th style={{ width: 60 }}>{AppLabels.id}</th>
					<th style={{ width: 60 }}>{AppLabels.start}</th>
					<th style={{ width: 60 }}>{AppLabels.end}</th>
					<th style={{ width: 60 }}>{AppLabels.durationms}</th>
					<th style={{ width: 60 }}>{AppLabels.serverDuration}</th>
					<th style={{ width: 60 }}>{AppLabels.status}</th>
					<th style={{ width: 60 }}>{AppLabels.serverStatus}</th>
					<th style={{ width: "90%" }}>{AppLabels.message}</th>
				</tr>
			</thead>
			<tbody>
				{
					this.state.rows.map((row, index) => {
						return (
							<KStressLine line={row} key={index} />
						);
					})
				}

			</tbody>
		</Table>);
	}

	render() {
		if (!securitySvc.isAuth()) return <Redirect to="/"></Redirect>

		let table = this.renderTable();

		return (
			<CContainer>
				<div className="KStress">
					<CLabel >{AppLabels.stressTitle}</CLabel>

					<div className="StressParams KAdminBorder">
						<CForm>
							<CFormGroup row>
								<CCol sm={2}>
									<CLabel >{AppLabels.targetPool}</CLabel>
								</CCol >
								<CCol sm={10}>
									<CInputGroup>
										<CInput type="text" name="wsName" placeholder={AppLabels.targetPool} value={this.state.wsPool} onChange={this.onWsPoolChange} />
										<CInputGroupAppend >
											<CDropdown>
												<CDropdownToggle caret color="secondary" />
												<CDropdownMenu >
													{
														this.state.poolList.map((x, i) =>
															<CDropdownItem key={i} onClick={() => this.setState({ wsPool: x.poolName })}>{x.poolName}</CDropdownItem>
														)
													}
												</CDropdownMenu>
											</CDropdown>
										</CInputGroupAppend>
									</CInputGroup>
								</CCol>
							</CFormGroup>

							<CFormGroup row>
								<CCol sm={2}>
									<CLabel >{AppLabels.pool}</CLabel>
								</CCol>
								<CCol sm={10}>
									<CInputGroup>
										<CInput type="text" readOnly={false} name="webService" onChange={this.onWsNameChange} placeholder={AppLabels.webServiceName} value={this.state.wsName} />
										<CInputGroupAppend>
											<CDropdown>
												<CDropdownToggle caret color="secondary" />
												<CDropdownMenu >
													<CDropdownItem onClick={() => this.setState({ wsName: "X1KMAPAGE" })}>X1KMPAGE</CDropdownItem>
													<CDropdownItem onClick={() => this.setState({ wsName: "X1KMALISTD" })}>X1KMALISTD</CDropdownItem>
													<CDropdownItem onClick={() => this.setState({ wsName: "X1KMALISTE" })}>X1KMALISTE</CDropdownItem>
													<CDropdownItem onClick={() => this.setState({ wsName: "X1KMAMENU" })}>X1KMAMENU</CDropdownItem>
													<CDropdownItem onClick={() => this.setState({ wsName: "X1KMALOGIN" })}>X1KMALOGIN</CDropdownItem>
												</CDropdownMenu>
											</CDropdown>
										</CInputGroupAppend>
									</CInputGroup>
								</CCol>
							</CFormGroup>

							<CFormGroup row>
								<CCol sm={2}>
									<CLabel>{AppLabels.callsNumber}</CLabel>
								</CCol>
								<CCol sm={10}>
									<CInput type="text" name="wsName" placeholder={AppLabels.callsNumber} value={this.state.nbCalls} onChange={this.onNbCallChange} />
								</CCol>
							</CFormGroup>

							<CFormGroup row>
								<CCol sm={2}>
									<CLabel >{AppLabels.interval}</CLabel>
								</CCol>

								<CCol sm={8}>
									<CInput type="range" min={1} max={this.state.intervalMax} name="interval" onChange={this.onIntervalChange} readOnly={false} value={this.state.interval} />
								</CCol>

								<CCol sm={2}>
									<CInputGroup>
										<CInput readOnly={true} value={this.state.interval} />

										<CButtonGroup>
											<CButton id="buttonUnit-ms" color={this.state.intervalUnit == "ms" ? "success" : "danger"} size="sm" onClick={this.onClickIntervalUnit}>ms</CButton>
											<CButton id="buttonUnit-s" color={this.state.intervalUnit == "s" ? "success" : "danger"} size="sm" onClick={this.onClickIntervalUnit} active={this.state.intervalUnit == "s"}>s</CButton>
										</CButtonGroup>
									</CInputGroup>
								</CCol>
							</CFormGroup>

							<CFormGroup row>
								<CCol sm={2}>
									<CLabel >{AppLabels.XMLEntry}</CLabel>
								</CCol>
								<CCol sm={10}>
									<CInput type="textarea" name="wsParams" onChange={this.onParamsChange} readOnly={false} value={this.state.wsParams} />
								</CCol>
							</CFormGroup>
						</CForm>
					</div>

					<CRow>
						<CCol xs={6} >
							<CButton color="primary" onClick={this.onClickLaunchStress} disabled={this.state.isRunning}>{AppLabels.run}</CButton>
							<CButton color="danger" onClick={this.onClickCancelStress} disabled={!this.state.isRunning}>{AppLabels.cancel}</CButton>
						</CCol>
					</CRow>

					{table}
				</div>
			</CContainer >
		);
	}
	//#endregion 
}
